import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]
  static values = {
    visibleWhen: { type: String, default: "checked" },
    clearWhenHidden: { type: Boolean, default: false }
  }

  connect() {
    this.update()
  }

  update() {
    const visible = this.visible()

    this.contentTargets.forEach((content) => {
      content.classList.toggle("hidden", !visible)

      if (!visible && this.clearWhenHiddenValue) {
        this.clearFields(content)
      }
    })
  }

  visible() {
    if (this.visibleWhenValue === "unchecked") {
      return !this.triggerTarget.checked
    }

    if (this.visibleWhenValue === "checked") {
      return this.triggerTarget.checked
    }

    return this.visibleWhenValue.split(",").includes(this.triggerTarget.value)
  }

  clearFields(content) {
    content.querySelectorAll("input, textarea, select").forEach((field) => {
      if (field.type === "checkbox" || field.type === "radio") {
        field.checked = false
      } else {
        field.value = ""
      }

      field.dispatchEvent(new Event("input", { bubbles: true }))
      field.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
